var React = require('react');

function Omkladningsrum (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m98.6 76.8-69.4 37.8c-4.5 2.5-2.7 9.4 2.4 9.4h128.9c5.2 0 7-6.7 2.6-9.3L98.6 76.8Zm0 0V71a14 14 0 0 1 3.5-9.3l4.3-4.7c1.8-2 3-4.5 2.8-7.2-.6-5-3.6-10.8-11.2-10.8-9.3 0-11.8 8.7-11.8 14.9","stroke":"#000","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Omkladningsrum.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Omkladningsrum;

Omkladningsrum.default = Omkladningsrum;
